<!-- Skip to content: required for accessibility -->
<lc-skip-to-content
  [secondContentID]="subNavId()"
  [secondContentButtonLabel]="subNavLabel()"
/>

<!-- Header -->
<header lcNavbar></header>

<!-- Main content (footer is rendered inside each page's CADIX page body) -->
<div class="flex-fill d-flex flex-column">
  <router-outlet></router-outlet>
</div>
